class ReadMore {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.content = self.elem.querySelector('[data-read-more-content]');
        self.button = self.elem.querySelector('[data-read-more-button]');
    }

    init() {
        let self = this;

        self.button.addEventListener('click', evt => {
            self.button.classList.toggle('is-active');
            self.content.classList.toggle('is-open');
        });
    };
}

export default ReadMore;
